export interface FeedbackRequestBody {
  sessionId: string;
  messageId: number;
  feedback: 1 | 2; // 1=Positive, 2=Negative
  agent?: string;
}

export interface FeedbackResponse {
  status: string;
  message: string;
}

export async function submitFeedback(
  body: FeedbackRequestBody,
  accessToken?: string
): Promise<FeedbackResponse> {
  const apiUrl = import.meta.env.VITE_API_URL;
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (accessToken) {
    headers["Authorization"] = `Bearer ${accessToken}`;
  }

  const fullUrl = `${apiUrl}/feedback`;
  const response = await fetch(fullUrl, {
    method: "POST",
    headers,
    credentials: "include",
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(
      `Feedback API error: ${response.status}: ${response.statusText}\n${errorText}`,
    );
  }

  return response.json();
}
